import React, {useEffect, useState} from 'react';
import DropDown from '../component/DropDown';
import Navbargap from '../component/Navbargap';
import NavbarNormal from '../component/NavbarNormal';
import EnqForm from '../component/submitForm/EnqForm';
import SendMsg from '../component/submitForm/SendMsg';
import FooterSection from '../component/FooterSection';
import TitlePart from '../component/sakleshpur/TitlePart';
import headingImg from '../media/coorg/title.jpg';
import { TextCoorg } from '../component/sakleshpur/TextSa';
import ProductPage from '../component/ProductSlider/ProductPage';
import { CoorgResort } from '../data/CoorgResort';


const Coorg = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [enOpen, setEnOpen] = useState(false);
    const [sendOpen, setSendOpen] = useState(false);
    const [enqyFor, setEnqyFor] = useState("");

    const toggle = () => {
        setIsOpen(!isOpen);
    }
    const enquiry = (enqData) => {
        setEnOpen(!enOpen);
        setEnqyFor(enqData);
    }
    const sendBox = () => {
        setSendOpen(!sendOpen);
    }
    useEffect(() => {
        window.scroll(0,0);
    },[]);
    return (
        <>
            <NavbarNormal toggle = {toggle}/>
            <DropDown isOpen = {isOpen} toggle = {toggle}/>
            <Navbargap />
            <TitlePart img = {headingImg} textData = {TextCoorg}/>
            <ProductPage enquiry = {enquiry} arraybox = {CoorgResort} boxname = {'Resort'} link ={"/coorg/resorts"}/>
            <EnqForm enForm = {enOpen} enFor = {enqyFor} enquiry = {enquiry} sendBox ={sendBox}/>
            <SendMsg dispSub = {sendOpen} sendBox ={sendBox}/>
            <FooterSection enquiry = {enquiry}/>
            
        </>
    )
}

export default Coorg
